// extracted by mini-css-extract-plugin
module.exports = {"color-navy":"#021135","colorNavy":"#021135","color-mischka":"#e0e1e7","colorMischka":"#e0e1e7","button":"B3BXv"};